import { AuthStatusRole } from "helpers/useAuthStatus";
import { RoutePermissions } from "routes";

/**
 * Indicates whether the user's roles match the required permissions for the
 * route.
 * @param userRoles
 * @param routePermissions
 * @returns
 */
export const rolesPermissionsMatch = (
	userRoles: AuthStatusRole,
	routePermissions?: RoutePermissions,
): boolean => {
	if (!routePermissions || routePermissions === "all") {
		return true;
	}

	const isUserAuthenticated = userRoles !== "unauthenticated";

	if (routePermissions === "unauthenticated") {
		// The user must be unauthenticated
		return !isUserAuthenticated;
	}

	if (routePermissions === "authenticated") {
		// Route matches all authenticated users
		return isUserAuthenticated;
	}

	if (userRoles === "admin") {
		return true;
	}

	if (userRoles === "admin-teacher") {
		return routePermissions.some(
			(permission) =>
				permission === "admin-teacher" || permission === "teacher",
		);
	}

	return routePermissions.some((permission) => userRoles === permission);
};
